import endpoints from 'helper/endpoints'
import {fireErrorToast, fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_CAR_FAIL,
  GET_CAR_LIST_FAIL,
  GET_CAR_LIST_REQUEST,
  GET_CAR_LIST_SUCCESS,
  GET_CAR_REQUEST,
  GET_CAR_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getCarList = (limit = 1000, offset = 0, meta = {}, filters = {}, search) => {
  return (dispatch) => {
    dispatch({type: GET_CAR_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.cars + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
        rz: filters?.rz ? filters.rz : null,
        vin: filters?.vin ? filters.vin : null,
        customer_id: filters?.customer_cfs ? filters.customer_cfs : null,
      })
      .then((res) => {
        dispatch({type: GET_CAR_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_CAR_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getCar = (id) => {
  return (dispatch) => {
    dispatch({type: GET_CAR_REQUEST})
    return httpClient
      .get(endpoints.cars + '/' + id)
      .then((res) => {
        dispatch({type: GET_CAR_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_CAR_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const createCar = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.cars, data)
      .then((res) => {
        fireSuccessToast(<Trans>New car created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

// Case 1 of the RSV integration: preview the fields RSV can fill for a VIN so the new-car
// form pre-fills them. The endpoint never fails toward the user (a foreign fleet, an unknown
// VIN or an RSV outage all return {}), so this action mirrors that - it resolves to the data
// or to {} and never surfaces an error toast.
export const lookupCarRsvData = (vin, fleetId) => {
  return () => {
    return httpClient
      .get(endpoints.carsRsvLookup, {vin: vin, fleet_id: fleetId})
      .then((res) => Promise.resolve(res.data || {}))
      .catch(() => Promise.resolve({}))
  }
}

export const patchCar = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.cars + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Car updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}
